import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Fonts, IconButton, Spacing } from "@snapchat/snap-design-system";

export const AccordionHeader = styled.div`
    cursor: pointer;

    display: flex;
    gap: ${Spacing.MD}px;
    align-items: center;

    padding: ${Spacing.MD}px 0;
`;
export const IconButtonStyled = styled(IconButton)<{ isExpanded: boolean }>`
    border: 0 !important; /* Override default SDS border */
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 14%) !important; /* Override default SDS box-shadow */

    svg {
        transform: rotate(${({ isExpanded }) => (isExpanded ? "0deg" : "-90deg")});
        transition: all 0.3s ease-in-out;
    }
`;

export const AccordionTitle = styled.h5`
    ${Fonts.Heading.H700};
    margin-bottom: 0;
`;

const animateIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const AccordionContent = styled.div<{ isExpanded: boolean }>`
    width: 100%;
    height: 100%;
    animation: ${animateIn} 0.3s ease-in-out;
`;
